module.exports = global["jQuery"] = require("-!e:\\build\\Roadmap-Release-19.1\\Source\\Nis.WebAgent\\frontend\\node_modules\\expose-loader\\index.js?$!.\\jquery.js");


//////////////////
// WEBPACK FOOTER
// ./node_modules/jquery/dist/jquery.js-exposed
// module id = 0
// module chunks = 1